<div class="flex-content">
  <div class="make_dimmer"></div>
  <div class="content col-sm container-fluid">
    <div class="row">
      <div class="logo">
        <img src="./../../../../assets/Contents/imgs/logo.svg" width="180"/>
      </div>

      <p class="display-2 col-12 publication-title">{{pubs[0].title}}</p>

      <div class="desc col-12">
        <div class="author-box">
          <a [routerLink]='["/main/people/person", author.id]' *ngFor="let author of pubs[0].authors; let isLast=last" >
            {{author.name}}{{isLast ? '' : ', '}}
          </a>
        </div>

        <h5 *ngIf="pubs[0].journal">Journal: {{pubs[0].journal}}</h5>

        <h5 *ngIf="pubs[0].conference">Conference: {{pubs[0].conference}}</h5>

        <!-- <h5 *ngIf="pubs[0].thesisInfo">{{pubs[0].thesisInfo}}</h5> -->

        <p>
          <!--<a *ngIf="pubs[0].paper" target="_blank" download type="application/octet-stream" [href]='imgPath +pubs[0].paper' target="_blank">Paper <mat-icon class="material-icons">file_download</mat-icon></a>-->  
          <a *ngIf="pubs[0].paper" target="_blank" [href]='imgPath +pubs[0].paper' target="_blank">Paper <mat-icon class="material-icons">file_download</mat-icon></a>
          <a *ngIf="pubs[0].slides" target="_blank" download type="application/octet-stream" [href]='imgPath +pubs[0].slides' target="_blank">/ Slides <mat-icon class="material-icons">file_download</mat-icon></a>  
          <a *ngIf="pubs[0].video" target="_blank" download type="application/octet-stream" [href]='imgPath +pubs[0].video' target="_blank">/ Video <mat-icon class="material-icons">file_download</mat-icon></a>  
          <a *ngIf="pubs[0].dateset" target="_blank" download type="application/octet-stream" [href]='imgPath +pubs[0].dataset' target="_blank">/ Dataset <mat-icon class="material-icons">file_download</mat-icon></a>  
          <a *ngIf="pubs[0].supplementary_material" target="_blank" download type="application/octet-stream" [href]='imgPath +pubs[0].supplementary_material' target="_blank">/ Supplementary Material <mat-icon class="material-icons">file_download</mat-icon></a>  
          <a *ngIf="pubs[0].project_page" target="_blank" [href]='imgPath +pubs[0].project_page' target="_blank">/ Open Project Page</a>  

          <!--<a href="#">Slides (PPTX, 204.3MB)</a> / 
          <a href="#">Videos</a> / 
          <a href="#">Supplemental document</a> /
          <a href="#">Code (ZIP, 43.2MB)</a> / 
          <a href="#">Datasets</a>-->

        </p>

        <div class="imgDiv">
          <img default="./assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + pubs[0].img" [src]=" imgPath + pubs[0].img" class="max-img">
        </div>
      </div>

      <!-- Examples -->

      <div class="col-12 abstract">
        <p class="h2">Abstract</p>
        <p>{{pubs[0].abstract}}</p>
      </div>
      
      <!-- <div class="col-sm-12 videoWrapper">
        <iframe width="1280" height="720" src="https://www.youtube.com/embed/ZVEAHutpv0M" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
      </div> -->

      <div class="videoURL embed-responsive embed-responsive-16by9" *ngIf="pubs[0].youtube?.length > 0" >
        <iframe class="videoURL embed-responsive-item" [src]="safeURL" allowfullscreen></iframe>
      </div>

      <div class="imgDiv subImgDiv" *ngIf="pubs[0].subimg1?.length > 0" >
        <img default="./assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + pubs[0].subimg1" [src]=" imgPath + pubs[0].subimg1" class="max-img">
      </div>

      <div class="col-12 abstract" *ngIf="pubs[0].subimg1_description?.length > 0">
        <p>{{pubs[0]?.subimg1_description}}</p>
      </div>

      <div class="imgDiv subImgDiv" *ngIf="pubs[0].subimg2?.length > 0" >
        <img default="./assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + pubs[0].subimg2" [src]=" imgPath + pubs[0].subimg2" class="max-img">
      </div>

      <div class="col-12 abstract" *ngIf="pubs[0].subimg2_description?.length > 0">
        <p>{{pubs[0]?.subimg2_description}}</p>
      </div>

      <div class="imgDiv subImgDiv" *ngIf="pubs[0].subimg3?.length > 0" >
        <img default="./assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + pubs[0].subimg3" [src]=" imgPath + pubs[0].subimg3" class="max-img">
      </div>

      <div class="col-12 abstract" *ngIf="pubs[0].subimg3_description?.length > 0">
        <p>{{pubs[0]?.subimg3_description}}</p>
      </div>


      <div class="col-12 abstract">
        <p class="h2">License</p>
        <p>All data is under <a href="https://creativecommons.org/licenses/by-nc/4.0/">a Creative Commons Attribution-Noncommercial 4.0 International License</a></p>
      </div>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/research-publicate-individual/research-publicate-individual.component.html